

import { BaseEntity, CommonSettingEntity } from '@m4u-angular/base/entities/BaseEntities';
import { BaseTransDocument } from './../entities/basetransdocument.entity';
import { BaseDocument } from './../entities/basedocument.entity';
export class Ledger extends BaseTransDocument
{   
    public Debit: number; 
    public Credit: number; 
    public DebitOpen: number; 
    public CreditOpen: number; 
	
}



